
import React, { useEffect, useState } from "react";
import {
    UseFormGetValues,
    UseFormSetValue,
} from "react-hook-form";


import {
    Field,
} from "../../types/field";
import { ReportingToUser } from "../../types/types";
import './waiverpaymentdetails.scss';


interface WaiverApprovalsInfo {
    bucket?: string,
    minWaiverPercentage?: number,
    componentCode: number,
    platformPojoName: string,
    authorityRole?: string,
    maxWaiverAmount?: number,
    minWaiverAmount?: number,
    maxWaiverPercentage?: number
}
interface WaiverHeadsAmounts {
    key: string;
    componentCode?: number;
    originalAmount?: number;
    collectedAmount?: number;
    excludeInTotal?: boolean;
}

interface waiverHeadsDetailsProps {
    fields: Field[],
    renderField: Function,
    getValue: UseFormGetValues<any>,
    setValue: UseFormSetValue<any>,
    viewData: any,
    waiverHeadFieldAmount: WaiverHeadsAmounts,
    reportingToUsers: ReportingToUser[],
    waiverApprovalMatrix: WaiverApprovalsInfo[],
    updateWaiverHeadFieldAmounts?: Function,
    recomputeCollectedAmount?: Function,
    onUpdateOfAuthorityEcode?: Function,
    moduleCode?: string,
    waiverSettlementStatus?: string,
    bucket?: string
}

interface ApprovalUserDetails {
    approvalEcode?: string;
    approvalUserName?: string;
    approvalRoleCode?: string;
    approvalRoleName?: string;
}


const WaiverHeadsDetails: React.FC<waiverHeadsDetailsProps> = ({
    fields,
    renderField,
    getValue,
    setValue,
    waiverHeadFieldAmount,
    reportingToUsers,
    waiverApprovalMatrix,
    updateWaiverHeadFieldAmounts = () => { },
    recomputeCollectedAmount = () => { },
    onUpdateOfAuthorityEcode,
    moduleCode,
    viewData,
    waiverSettlementStatus,
    bucket
}) => {

    let actualDueField: Field = fields[0];
    let amountCollectedField: Field = fields[1];
    let outstandingWaiverPercField: Field = fields[3];
    let outstandingWaiverField: Field = fields[2];
    let approvingAuthorityEcode: Field = fields[4] ?? {};
    //const waiverHeadFieldAmount: WaiverHeadsAmounts = waiverHeadFieldAmounts.find(amountField => amountField.key === actualDueField.field) ?? { key: actualDueField.field, originalAmount: 0, collectedAmount: 0 };
    const [approvalReqInfo, setApprovalReqInfo] = useState<ApprovalUserDetails>({});
    // const [waiverHeadFieldAmount, setWaiverHeadFieldAmount] = useState<WaiverHeadsAmounts>(waiverHeadFieldAmounts.find(amountField => amountField.key === actualDueField.field) ??{ key: actualDueField.field, originalAmount: 0, collectedAmount: 0 });



    const handleDueAmountChanges = (fieldId: string, fieldValue: number) => {

        if (fieldId === actualDueField.field) {
            waiverHeadFieldAmount.originalAmount = fieldValue;
            waiverHeadFieldAmount.collectedAmount = getValue()[amountCollectedField.field];
        } else if (fieldId === amountCollectedField.field) {
            waiverHeadFieldAmount.collectedAmount = fieldValue;
            waiverHeadFieldAmount.originalAmount = getValue()[actualDueField.field];
        }

        updateWaiverHeadFieldAmounts(actualDueField.field, { ...waiverHeadFieldAmount });
    }

    const handleOnChangeEvent = (event: any) => {
        // Handle the custom event from the child component here
        const eventField = event.detail.field;
        let fieldNewValue = event.detail.value;
        if (isNaN(fieldNewValue) || fieldNewValue === "") {
            fieldNewValue = "";
        }
        if (eventField.field === actualDueField.field || eventField.field === amountCollectedField.field) {
            handleDueAmountChanges(eventField.field, parseFloat(fieldNewValue));
            if (recomputeCollectedAmount) {
                recomputeCollectedAmount();
            }
        }
    };

    function calculatePercentage(value: number, total: number) {
        if (total === 0) {
            return 0;
        }
        return (value / total) * 100;
    }


    useEffect(() => {
        document.addEventListener('onchange', handleOnChangeEvent);
        // setWaiverHeadFieldAmount(waiverHeadFieldAmounts.find(amountField => amountField.key === actualDueField.field) ?? { ...waiverHeadFieldAmount });
        return () => {
            document.removeEventListener('onchange', handleOnChangeEvent);
        };
    }, []);

    useEffect(() => {

        if (moduleCode !== 'waiverApproval') {
            // const waiverHeadFieldAmount = waiverHeadFieldAmounts.find(amountField => amountField.key === actualDueField.field) ?? { key: actualDueField.field, originalAmount: 0, collectedAmount: 0 };
            setValue(actualDueField.field, waiverHeadFieldAmount.originalAmount ?? 0);
            setValue(amountCollectedField.field, waiverHeadFieldAmount.collectedAmount ?? 0);

            const waiverAmount: number = waiverHeadFieldAmount.originalAmount! - waiverHeadFieldAmount.collectedAmount!;
            const waiverPerc: number = calculatePercentage(waiverHeadFieldAmount.originalAmount! - waiverHeadFieldAmount.collectedAmount!, waiverHeadFieldAmount.originalAmount!);
            setValue(outstandingWaiverField.field, Number.isNaN(waiverAmount) ? 0 : waiverAmount);
            setValue(outstandingWaiverPercField.field, Number.isNaN(waiverPerc) ? 0 : Math.round(waiverPerc * 100) / 100);

            const waiverApprovalsPercInfo: WaiverApprovalsInfo | undefined = waiverApprovalMatrix.filter(matrix => matrix.platformPojoName === outstandingWaiverPercField.field)
                .filter(matrix => matrix.bucket? matrix.bucket === bucket: true)
                .filter(matrix => (waiverAmount >= (matrix.minWaiverAmount ?? 0) && waiverAmount <= (matrix.maxWaiverAmount ?? waiverAmount)))
                .find(matrix => (waiverPerc >= (matrix.minWaiverPercentage ?? 0) && waiverPerc <= (matrix.maxWaiverPercentage ?? 0)));

            const waiverApprovalsAmountInfo: WaiverApprovalsInfo | undefined = waiverApprovalMatrix.filter(matrix => matrix.platformPojoName === outstandingWaiverField.field)
                .filter(matrix => matrix.bucket? matrix.bucket === bucket: true)
                .find(matrix => (waiverAmount >= (matrix.minWaiverAmount ?? 0) && waiverAmount <= (matrix.maxWaiverAmount ?? 0)));

            if (waiverApprovalsPercInfo && waiverApprovalsPercInfo.hasOwnProperty("authorityRole")) {
                const reportingToUser: ReportingToUser | undefined = reportingToUsers.find(user => user.roleCode === waiverApprovalsPercInfo.authorityRole!);
                setApprovalReqInfo({ approvalEcode: reportingToUser?.ecode, approvalUserName: reportingToUser?.name, approvalRoleName: reportingToUser?.roleName });
                if (approvingAuthorityEcode.field) {
                    setValue(approvingAuthorityEcode.field, (reportingToUser?.ecode) ? (reportingToUser?.ecode + "--" + (reportingToUser?.name ?? "") + "--" + (reportingToUser?.roleName ?? "")) : "");
                }
            } else if (waiverApprovalsAmountInfo && waiverApprovalsAmountInfo.hasOwnProperty("authorityRole")) {
                const reportingToUser: ReportingToUser | undefined = reportingToUsers.find(user => user.roleCode === waiverApprovalsAmountInfo.authorityRole!);
                setApprovalReqInfo({ approvalEcode: reportingToUser?.ecode, approvalUserName: reportingToUser?.name, approvalRoleName: reportingToUser?.roleName });
                if (approvingAuthorityEcode.field) {
                    setValue(approvingAuthorityEcode.field, (reportingToUser?.ecode) ? (reportingToUser?.ecode + "--" + (reportingToUser?.name ?? "") + "--" + (reportingToUser?.roleName ?? "")) : "");
                }
            } else {
                setApprovalReqInfo({});
                if (approvingAuthorityEcode.field) {
                    setValue(approvingAuthorityEcode.field, null);
                }
            }
            if (onUpdateOfAuthorityEcode) {
                onUpdateOfAuthorityEcode();
            }
        } else {
            const authirityUserInfo: string[] = viewData[approvingAuthorityEcode.field]?.split("--") ?? [];
            if (authirityUserInfo.length > 0) {
                setApprovalReqInfo({ approvalEcode: authirityUserInfo[0], approvalUserName: authirityUserInfo[1] ?? "-", approvalRoleName: authirityUserInfo[2] ?? "-" });
            }
        }
    }, [waiverHeadFieldAmount]);



    return (<>


        {(() => {

            return <>

                {fields.map((field: Field, index: number) => {
                    return (
                        < >
                            {renderField(field)}
                        </>);
                })
                }
                {(approvalReqInfo.approvalEcode != null && approvalReqInfo.approvalEcode != undefined) && (
                    <div className="waiver-head-note mx-3 px-2 rounded">
                        <span className="font-medium">Approving Authority : </span>
                        <span className="font-semibold">
                            {approvalReqInfo.approvalEcode} - {approvalReqInfo.approvalUserName} ({approvalReqInfo.approvalRoleName})
                        </span>
                    </div>
                )}
            </>
        })()}


    </>
    )
};

export default WaiverHeadsDetails;